import PropTypes from "prop-types";
const PropTypeInput = {
  pattern: PropTypes.string,
  infoMessage: PropTypes.string,
  warningMessage: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  hasError: PropTypes.bool,
};
export default PropTypeInput;
